@if (pagelet()?.hasParam('HTML')) {
<div [ishServerHtml]="pagelet().stringParam('HTML')"></div>
}
